<ag-grid-angular
		#agGrid
		class="ag-theme-alpine"
		[rowData]="dataSource"
		[columnDefs]="columns"
		[gridOptions]="gridOptions"
		(gridReady)="onGridReady()">
</ag-grid-angular>
